import http from '../../../../http';
import { SERVER_URL } from '../../../../config';

export const getSearchData = (params) => http.get(`${SERVER_URL}/api-main/v1/search`, { params: { ...params } });
export const getCategorieshData = () => http.get(`${SERVER_URL}/api-main/v1/categories`, {});
